"use client";

import { useEffect, useState } from "react";

const PANE_EXIT_MS = 300;

type PanePhase = "unmounted" | "collapsed" | "expanded";

// Mount collapsed before expanding so width transitions can start from zero.
export const usePaneLifecycle = (open: boolean) => {
  const [phase, setPhase] = useState<PanePhase>(
    open ? "expanded" : "unmounted"
  );

  if (open && phase === "unmounted") setPhase("collapsed");
  else if (!open && phase === "expanded") setPhase("collapsed");

  useEffect(() => {
    if (open) {
      const frame = requestAnimationFrame(() => setPhase("expanded"));
      return () => cancelAnimationFrame(frame);
    }
    const timer = window.setTimeout(() => setPhase("unmounted"), PANE_EXIT_MS);
    return () => window.clearTimeout(timer);
  }, [open]);

  return {
    isMounted: phase !== "unmounted",
    isExpanded: phase === "expanded",
  };
};
